import { buildScene, frameWidthFor, type ProjectState, type Scene } from '@better-lights/core';

/** The scene at photo resolution for the current document (docs/spec/03 §2.1). */
export function sceneFor(
  s: Pick<ProjectState, 'photo' | 'runs' | 'time' | 'style' | 'colorId' | 'frameWidthFt'>,
  customHex: string,
): Scene | null {
  if (!s.photo) return null;
  return buildScene({
    width: s.photo.width,
    height: s.photo.height,
    time: s.time,
    runs: s.runs,
    style: s.style,
    colorId: s.colorId,
    customHex,
    frameWidthFt: frameWidthFor(s.frameWidthFt, s.runs, s.photo),
  });
}

/** Whether a document change requires re-rendering the scene texture. */
export function sceneInputsChanged(a: ProjectState, b: ProjectState): boolean {
  return (
    a.photo !== b.photo ||
    a.runs !== b.runs ||
    a.time !== b.time ||
    a.style !== b.style ||
    a.colorId !== b.colorId ||
    a.frameWidthFt !== b.frameWidthFt ||
    a.view !== b.view
  );
}
